import CompareProperty from './compare-property'

export default CompareProperty
